import { render, staticRenderFns } from "./CarbonEmissionsCalculations.vue?vue&type=template&id=805348d8&scoped=true&"
import script from "./CarbonEmissionsCalculations.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CarbonEmissionsCalculations.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CarbonEmissionsCalculations.vue?vue&type=style&index=0&id=805348d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805348d8",
  null
  
)

export default component.exports